export const VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_REQUEST = 'VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_REQUEST';
export const validateAddressSalesOrderShipTo = (address, email, salesOrderId, fulfillmentPlanId) => {
  return {
    type: VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_REQUEST,
    address,
    email,
    salesOrderId,
    fulfillmentPlanId,
  };
};

export const VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_SUCCESS = 'VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_SUCCESS';
export const validateAddressSalesOrderShipToSuccess = (addressValidationResponses, email, address, salesOrderId, fulfillmentPlanId) => {
  return {
    type: VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_SUCCESS,
    addressValidationResponses,
    email,
    address,
    salesOrderId,
    fulfillmentPlanId,
  };
};

export const VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_FAILURE = 'VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_FAILURE';
export const validateAddressSalesOrderShipToFailure = (address) => {
  return {
    type: VALIDATE_ADDRESS_SALES_ORDER_SHIP_TO_FAILURE,
    address,
  };
};

export const LOG_PASTE_ADDRESS_USAGE = 'LOG_PASTE_ADDRESS_USAGE';
export const logPasteAddressUsage = () => ({
  type: LOG_PASTE_ADDRESS_USAGE,
});
